import { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardQuestion, faCode, faBookOpen } from "@fortawesome/free-solid-svg-icons";

export interface AddContentModalProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onChooseLesson: () => void;
  readonly onChooseQuiz: () => void;
  readonly onChoosePresentation: () => void;
}

export function AddContentModal({
  open,
  onClose,
  onChooseLesson,
  onChooseQuiz,
  onChoosePresentation,
}: AddContentModalProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const el = dialogRef.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    if (!open && el.open) el.close();
  }, [open]);

  return (
    <dialog ref={dialogRef} className="teacher-modal" onClose={onClose}>
      <div className="teacher-modal-card" role="document">
        <h2 className="teacher-modal-title">Add to course plan</h2>
        <p className="teacher-modal-lede">Choose what to add to this spot in the sequence.</p>
        <div className="add-content-choices">
          <button type="button" className="add-content-choice" onClick={onChooseLesson}>
            <FontAwesomeIcon icon={faCode} />
            <span className="add-content-choice-title">Lesson</span>
            <span className="add-content-choice-lede">Coding exercise in the IDE</span>
          </button>
          <button type="button" className="add-content-choice" onClick={onChooseQuiz}>
            <FontAwesomeIcon icon={faClipboardQuestion} />
            <span className="add-content-choice-title">Quiz</span>
            <span className="add-content-choice-lede">Multiple-choice knowledge check</span>
          </button>
          <button type="button" className="add-content-choice" onClick={onChoosePresentation}>
            <FontAwesomeIcon icon={faBookOpen} />
            <span className="add-content-choice-title">Presentation</span>
            <span className="add-content-choice-lede">Slides that introduce the next exercise</span>
          </button>
        </div>
        <div className="teacher-modal-actions">
          <button type="button" className="btn secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </dialog>
  );
}
